import { Box } from '@mui/material';
import { Button } from 'system/atoms';
import { Dropdown } from 'components/DropDown';
import { ModalContainer } from 'components/Modals/ModalContainer';
import { useCandidateDecision } from 'pages/CandidatesRanking/hooks/useCandidateDecision';
import { useMemo, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { useMutation } from 'services/api/hooks';
import { updateCandidate } from 'services/candidate/api';
import { candidateShortlistingModalAtom } from 'services/candidate/atoms';
import { CandidateStatus } from 'services/candidate/types';
import { useInterviewStages } from 'services/integration/hooks';

const buttonsContainer = {
  display: 'flex',
  justifyContent: 'space-between',
  mt: 4
};

type Props = {
  atsJobId: string | undefined | null;
};

export const CandidateShortListingModal: React.FC<Props> = ({ atsJobId }) => {
  const { interviewStages, isEnabled } = useInterviewStages({ atsJobId });
  const [interviewStage, setInterviewStage] = useState<string>('');
  const { candidateIds, candidateBatchId, isOpen } = useRecoilValue(
    candidateShortlistingModalAtom
  );
  const { closeModals } = useCandidateDecision({ atsJobId });

  const { mutate: updateCandidateAction } = useMutation(updateCandidate, {
    onSuccess: () => {
      closeModals();
    },
    disableSuccessToast: true
  });

  const subtitle = useMemo(() => {
    if (isEnabled) {
      return 'Select the interview stage to move the candidate to';
    }

    return 'Shortlisting candidate will change their status';
  }, [isEnabled]);

  const shortList = async (interviewStageId: string | undefined) => {
    if (!candidateIds.length || !candidateBatchId) {
      return;
    }

    const selectedStage = interviewStages.find(
      (s) => s.id === interviewStageId
    );

    await Promise.all(
      candidateIds.map((candidateId) =>
        updateCandidateAction({
          id: candidateId,
          status: CandidateStatus.SHORT_LISTED,
          atsInterviewStageId:
            selectedStage?.remoteId || interviewStageId || undefined,
          komboStageId: selectedStage?.remoteId ? interviewStageId : undefined
        })
      )
    );
  };

  const onShortListClick = async () => {
    closeModals();
    await shortList(interviewStage);
  };

  return (
    <ModalContainer
      title="Are you sure?"
      onClose={closeModals}
      open={isOpen}
      subtitle={subtitle}
    >
      {isEnabled && (
        <Dropdown
          options={interviewStages.map((reason) => ({
            label: reason.name,
            value: reason.id
          }))}
          onChange={(id) => setInterviewStage(id)}
          value={interviewStage}
          placeholder="Interview stage"
        />
      )}
      <Box sx={buttonsContainer}>
        <Button onClick={onShortListClick} variant="primary" fullWidth>
          Shortlist
        </Button>
        <Button
          onClick={closeModals}
          variant="tertiary"
          state="destructive"
          fullWidth
        >
          Cancel
        </Button>
      </Box>
    </ModalContainer>
  );
};
